// extracted by mini-css-extract-plugin
export default {"backBtn":"BackButton-module_backBtn__sH2sP","label":"BackButton-module_label___cdpb","rtl":"BackButton-module_rtl__yp0QQ","arrow":"BackButton-module_arrow__cqQaW"};